import { gql } from '@apollo/client'

export const LOGIN = gql`
  mutation Login($email: String!, $password: String!) {
    tokenAuth(email: $email, password: $password) {
      success
      errors
      token
      refreshToken
    }
  }
`

export const REFRESH_TOKEN = gql`
  mutation RefreshToken($refresh: String!) {
    refreshToken(refreshToken: $refresh) {
      token
      success
      errors
    }
  }
`

export const REVOKE_TOKEN = gql`
  mutation RevokeToken($refresh: String!) {
    revokeToken(refreshToken: $refresh) {
      success
      errors
    }
  }
`

export const REGISTER = gql`
  mutation Register(
    $email: String!
    $username: String!
    $fullName: String!
    $password1: String!
    $password2: String!
  ) {
    register(
      email: $email
      username: $username
      fullName: $fullName
      password1: $password1
      password2: $password2
    ) {
      success
      errors
      token
      refreshToken
    }
  }
`

// to add email 1 and 2 (trial)
export const UPDATE_USER = gql`
  mutation UpdateAccount(
    $email: String!
    $username: String!
    $fullName: String!
    $password1: String!
    $password2: String!
  ) {
    updateAccount(
      email: $email
      username: $username
      fullName: $fullName
      password1: $password1
      password2: $password2
    ) {
      success
      errors
      token
      refreshToken
    }
  }
`

export const CHANGE_PASSWORD = gql`
  mutation PasswordChange(
    $oldPassword: String!
    $newPassword1: String!
    $newPassword2: String!
  ) {
    passwordChange(
      oldPassword: $oldPassword
      newPassword1: $newPassword1
      newPassword2: $newPassword2
    ) {
      success
      errors
    }
  }
`
export const RESEND_VERIFICATION_EMAIL = gql`
  mutation ResendVerificationEmail($email: String!) {
    resendActivationEmail(email: $email) {
      success
      errors
    }
  }
`

export const VERIFY_ACCOUNT = gql`
  mutation VerifyAccount($token: String!) {
    verifyAccount(token: $token) {
      success
      errors
    }
  }
`

export const RESET_PASSWORD_EMAIL = gql`
  mutation SendPasswordResetEmail($email: String!) {
    sendPasswordResetEmail(email: $email) {
      success
      errors
    }
  }
`

export const RESET_PASSWORD = gql`
  mutation PasswordReset(
    $token: String!
    $newPassword1: String!
    $newPassword2: String!
  ) {
    passwordReset(
      token: $token
      newPassword1: $newPassword1
      newPassword2: $newPassword2
    ) {
      success
      errors
    }
  }
`
